/* global DISPLAY_DATE_FORMAT */
import PropTypes from 'prop-types'
import React from 'react'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'

import { certificateDownloadUrl } from 'reduxModules/certificates/selectors'

import './styles.css'

function Certificate({ certificate, token = '', onClaim }) {
  const { id, tutorial, completedAt, isClaimed, printedName } = certificate

  return (
    <div className="certificate-card">
      <div className="certificate-card__thumb">
        <div
          className="certificate-card__photo"
          style={
            tutorial.photo
              ? { backgroundImage: `url(${tutorial.photo})` }
              : undefined
          }
        />
        <span className="certificate-card__seal" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14">
            <path
              fill="currentColor"
              d="M9.55 17.6 4.4 12.45l1.42-1.42 3.73 3.72 8.23-8.23 1.42 1.42z"
            />
          </svg>
        </span>
      </div>
      <div className="certificate-card__info">
        <Link
          to={`/tutorials/${tutorial.slug}`}
          className="certificate-card__title"
        >
          {tutorial.title}
        </Link>
        <span className="certificate-card__date">
          Completed on {dayjs(completedAt).format(DISPLAY_DATE_FORMAT)}
        </span>
      </div>
      <div className="certificate-card__actions">
        {isClaimed ? (
          <>
            <a
              href={certificateDownloadUrl(id, token)}
              target="_blank"
              rel="noreferrer"
              className="btn -orange -mini certificate-card__btn"
            >
              Download PDF
            </a>
            <span className="certificate-card__issued">
              <span className="certificate-card__issued-label">Issued to</span>
              <button
                type="button"
                className="certificate-card__name"
                onClick={onClaim}
                title={printedName}
                aria-label={`Edit the name on this certificate: ${printedName}`}
              >
                {printedName}
              </button>
            </span>
          </>
        ) : (
          <button
            type="button"
            className="btn -orange -mini certificate-card__btn"
            onClick={onClaim}
          >
            Get Certificate
          </button>
        )}
      </div>
    </div>
  )
}

Certificate.propTypes = {
  certificate: PropTypes.shape({
    id: PropTypes.number,
    tutorial: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      photo: PropTypes.string
    }).isRequired,
    completedAt: PropTypes.string.isRequired,
    isClaimed: PropTypes.bool,
    printedName: PropTypes.string
  }).isRequired,
  token: PropTypes.string,
  onClaim: PropTypes.func.isRequired
}

export default Certificate
